module.exports = __webpack_public_path__ + "img/03-6.2631f056.png";